module.exports = __webpack_public_path__ + "static/media/test.a1ce4d1e.mp4";